import { typographyRem } from '@by-miles/bymiles-styles'
import React from 'react'

import { ReactComponent as MonthlyImage } from './images/monthly-explainer.svg'
import { ReactComponent as YearlyImage } from './images/yearly-explainer.svg'
import { PayByMileExplainerStyles } from './PayByMileExplainerStyles'
const { h4: H4, h5: H5, paragraphLead: ParagraphLead } = typographyRem

interface PayByMileExplainerProps {
  isRefundAtRenewal: boolean
}

export const PayByMileExplainer = ({ isRefundAtRenewal }: PayByMileExplainerProps) => {
  const copy = isRefundAtRenewal
    ? {
        image: <YearlyImage className="image" />,
        title: 'Your estimate for the year.',
        para1:
          'The amount you pay today includes cover for your car while it’s parked, plus the miles you’ve estimated you’ll drive - charged at your per-mile rate.',
        para2:
          'If you drive less than your estimate, you’ll be refunded for each and every mile you haven’t used at the end of the policy.',
        para3: 'If you need more miles, just top up in our app, or pay for them in monthly statements.',
      }
    : {
        image: <MonthlyImage className="image" />,
        title: 'Your monthly statements.',
        para1:
          'Each month, you’ll pay a fixed cost to cover your car while parked - plus a per-mile rate for the miles you drive.',
        para2:
          'The amount you pay each month is based on your miles. So the less you drive, the less you’ll pay. And if you need to drive more, you’ll simply pay more. You’re at the wheel.',
      }
  const { title, image, para1, para2 } = copy
  return (
    <PayByMileExplainerStyles>
      <H4 className="component-heading">Your estimate explained.</H4>
      <div className="pay-by-mile-explainer-container">
        <div className="explainer-image-container">{image}</div>
        <div className="explainer-content-container">
          <H5>{title}</H5>
          <ParagraphLead className="content-text">{para1}</ParagraphLead>
          <ParagraphLead className="content-text">{para2}</ParagraphLead>
          {copy.para3 && <ParagraphLead className="content-text">{copy.para3}</ParagraphLead>}
        </div>
      </div>
    </PayByMileExplainerStyles>
  )
}
